import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { AchievementsRoutingModule } from './achievements-routing.module';
import { AchievementsListComponent } from './achievements-list/achievements-list.component';
import { AchievementsCreateComponent } from './achievements-create/achievements-create.component';

@NgModule({
  declarations: [AchievementsListComponent, AchievementsCreateComponent],
  imports: [
    CommonModule,
    AchievementsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class AchievementsModule { }
